import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __assign } from "tslib";
import { useService } from '@kaokei/use-vue-service';
import { ExamService } from '@/services/exam/exam.service';
import { computed, defineComponent, reactive, watch } from 'vue';
import { value2label, QUESTION_TYPE, QUESTION_TYPE_FILE, IS_QUESTION_TYPE_FILE } from '@/utils';
import Image from './Image.vue';
import CustomAudio from './CustomAudio.vue';
import QsFileUpload from './QsFileUpload.vue';
export default defineComponent({
  name: 'QuestionChoice',
  components: {
    Image: Image,
    CustomAudio: CustomAudio,
    QsFileUpload: QsFileUpload
  },
  props: {
    question: {
      type: Object,
      default: function () {
        return {};
      }
    },
    answerMode: {
      type: Boolean,
      default: false
    },
    currentPaperAnswer: {
      type: String
    }
  },
  setup: function (props, _a) {
    var emit = _a.emit;
    var examService = useService(ExamService);
    var userAnswer = examService.getUserAnswerByQuestionId(props.question.id);
    var attachmentConfig = reactive({
      title: (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.creationTitle) || ''
    });
    var attachmentAnswerMap = reactive({});
    watch(function () {
      return props.question;
    }, function (newVal) {
      var _a, _b;
      if ((_b = (_a = newVal === null || newVal === void 0 ? void 0 : newVal.commonAnswer) === null || _a === void 0 ? void 0 : _a.answerRules) === null || _b === void 0 ? void 0 : _b.length) {
        newVal.commonAnswer.answerRules.forEach(function (item) {
          attachmentAnswerMap[item.fileDescriptionKey] = __assign(__assign({}, item), {
            userAnswer: item.userAnswer || ''
          });
        });
      }
    }, {
      immediate: true
    });
    var fileTypeMap = {
      'application/pdf': 'pdf',
      'image/jpeg': 'jpeg',
      'image/jpg': 'jpg',
      'video/mp4': 'mp4'
    };
    var getFileType = function (fileType) {
      var typeArr = fileType.split(',');
      var typeArrSimple = typeArr.map(function (item) {
        return fileTypeMap[item];
      });
      return typeArrSimple.join(',');
    };
    var getFileTypeZh = function (fileType) {
      if (fileType.startsWith('image')) {
        return '图片';
      }
      if (fileType.startsWith('video')) {
        return '视频';
      }
      return '文件';
    };
    var getFileTypeIcon = function (fileType) {
      if (fileType.startsWith('image')) {
        return 'pic';
      }
      if (fileType.startsWith('video')) {
        return 'video';
      }
      if (fileType.endsWith('pdf')) {
        return 'pdf';
      }
      return '';
    };
    var getFileLimitShow = function (fileByte) {
      var limit = Math.floor(fileByte / 1024 / 1024);
      return "".concat(limit, "MB");
    };
    var getTimeLimitShow = function (durationSecond) {
      var limit = Math.floor(durationSecond / 60);
      return durationSecond ? "".concat(limit, "\u5206\u949F") : '';
    };
    var answerRules = computed(function () {
      var _a, _b;
      return (((_b = (_a = props.question) === null || _a === void 0 ? void 0 : _a.commonAnswer) === null || _b === void 0 ? void 0 : _b.answerRules) || []).map(function (item) {
        return __assign(__assign({}, item), {
          fileTypeLimitDesc: "\u8BF7\u4E0A\u4F20".concat(getFileType(item.fileType), "\u683C\u5F0F\u7684").concat(getFileTypeZh(item.fileType)),
          fileSizeLimitDesc: item.fileByte ? "\u6587\u4EF6\u5927\u5C0F\u4E0D\u8D85\u8FC7".concat(getFileLimitShow(item.fileByte)) : '',
          fileDurationLimitDesc: item.durationSecond ? "\u89C6\u9891\u65F6\u957F\u4E0D\u8D85\u8FC7".concat(getTimeLimitShow(item.durationSecond)) : '',
          fileTypeStr: getFileType(item.fileType),
          fileTypeZh: getFileTypeZh(item.fileType),
          fileTypeIcon: getFileTypeIcon(item.fileType)
        });
      });
    });
    var onFileUploaded = function (answerData) {
      attachmentAnswerMap[answerData.fileDescriptionKey] = answerData;
    };
    var onSaveAction = function () {
      var answerDataList = Object.values(attachmentAnswerMap);
      if (!answerDataList.filter(function (el) {
        return el.userAnswer;
      }).length) {
        _message.error('请先上传文件');
        return;
      }
      if (!validateTitle(attachmentConfig.title)) {
        return;
      }
      emit('change', answerDataList, props.question, attachmentConfig.title);
    };
    var validateTitle = function (title) {
      var titleReg = /^[\u4e00-\u9fff\u3400-\u4dbf\uF900-\uFAFFa-zA-Z0-9_\-/()（）]{1,20}$/;
      if (!title) {
        _message.error('请输入科创作品名称');
        return false;
      }
      if (!titleReg.test(title)) {
        _message.error('科创作品名称只能包含中文、英文、数字和部分符号（-_/()），且不能超过20个字');
        return false;
      }
      return true;
    };
    return {
      answerRules: answerRules,
      getFileType: getFileType,
      value2label: value2label,
      QUESTION_TYPE: QUESTION_TYPE,
      QUESTION_TYPE_FILE: QUESTION_TYPE_FILE,
      IS_QUESTION_TYPE_FILE: IS_QUESTION_TYPE_FILE,
      onFileUploaded: onFileUploaded,
      onSaveAction: onSaveAction,
      attachmentConfig: attachmentConfig
    };
  }
});